import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IYii } from '../../../../globals';
import {JoditAngularComponent} from '../../../jodit/jodit-angular.component';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-rich-text',
  standalone: true,
  imports: [
    FormsModule,
    JoditAngularComponent
  ],
  template: `
    <jodit-editor [(ngModel)]="field.field_value"></jodit-editor>
  `,
})
export class FieldRichText {
  Yii = Yii;
  @Input() field: any;
}
